export function isValidRegExp(input) {
    try {
        new RegExp(input);
        return true;
    }
    catch (_a) {
        return false;
    }
}
